
const LinkPreviewUI = ({ data, handleCloseClick }) => {
    return (
        <div className="p-4 relative">
            <button
                type="button"
                class="absolute top-3 right-3 z-10 p-1.5 rounded-full bg-gray-900/70 bg-gray-900 text-white  transition-all duration-200 hover:scale-110"
                aria-label="Close preview"
                onClick={handleCloseClick}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x">
                    <path d="M18 6 6 18"></path>
                    <path d="m6 6 12 12"></path>
                </svg>
            </button>
            <a className="flex flex-col md:flex-row items-center shadow-md rounded-md border border-gray-100" href={data.url} target="_blank">
                <div class="flex-shrink-0 sm:w-48 w-full  h-24 h-24 relative overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200">
                    <img src={data.image} alt="wefayo" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                </div>
                <div className="flex flex-col p-4">

                    <h3 class="font-bold text-purple-900 text-base leading-tight mb-2 line-clamp-2 group-hover:text-blue-600 transition-colors duration-200 flex flex-row items-center justify-start ">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-external-link mr-1"><path d="M15 3h6v6"></path><path d="M10 14 21 3"></path><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path></svg>
                        {data.title}
                    </h3>
                    <p class="text-gray-600 text-sm leading-relaxed line-clamp-2 mb-3">{data.description}</p>
                </div>
            </a>
        </div>
    );
};

export default LinkPreviewUI;